import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import SalesReportService from "../../../services/OrderingServices/SalesReportService";
import {
  formatDate,
  formatDateTimes,
} from "../../../Components/Common/FormatDate";
import ReturnBill from "../component/ReturnBill";
import SalesReportDetail from "../component/SalesReportDetail";
import { exportToExcel } from "../../../utilis/exportToExcel";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const SalesReport = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  console.log("🚀 ~ SalesReport ~ selectedItem:", selectedItem);
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [responseData, setResponseData] = useState();

  const toggleDetailModal = (row) => {
    setIsDetailOpen(!isDetailOpen);
    setSelectedItem(row);
  };
  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Invoice No",
      selector: (row) => `${row.invoiceNumber}`,
      cell: (row) => row.invoiceNumber,
      sortable: true,
    },
    {
      name: "Order Ref Id",
      selector: (row) => (
        <Link to={`/order/${row?.orderReferenceId}`}>
          {row.orderReferenceId}
        </Link>
      ),
      sortable: true,
      width: "17vw",
    },
    {
      name: "Bill Date",
      selector: (row) => formatDateTimes(row.billDate),
      sortable: true,
      width: "14vw",
    },

    {
      name: "Discount(%)",
      selector: (row) => row.discountPercentage,
      sortable: true,
      right: true,
    },
    {
      name: "Total",
      selector: (row) => row.grandTotal,
      sortable: true,
      right: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <>
          <Button
            color="btn btn-soft-success"
            className="btn-sm"
            onClick={() => toggleDetailModal(row)}
          >
            <i className="bx bx-show" />
          </Button>

          {!row.isReturned && (
            <Button
              className="btn btn-soft-danger btn-sm ms-1"
              color="danger"
              onClick={() => handleDeleteClick(row)}
            >
              Return
            </Button>
          )}
        </>
      ),
      center: true,
    },
  ];

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await SalesReportService.getList();

      setData(response);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchCustomers();
  }, []);
  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = data.filter((pkg) => {
    // console.log("🚀 ~ filteredPackages ~ pkg:", pkg);

    // Combine name, surname, email, and phone number into a single search context, handling undefined fields
    const searchContext = `${pkg?.invoiceNumber || ""} ${
      pkg?.orderReferenceId || ""
    }`.toLowerCase();

    // Check if the filterText is included in any of the search context
    const matchesFilter = searchContext.includes(filterText.toLowerCase());

    return matchesFilter;
  });
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    toggleDeleteModal();
  };
  //   const handleReturn = async () => {
  //   if (!remarks?.trim()) {
  //     setTouched(true);
  //     return;
  //   }

  //   if (selectedItem) {
  //     try {
  //       const response = await SalesReportService.returnBill({
  //         refSalesInvoiceNumber: selectedItem?.invoiceNumber,
  //         customerPan: pan,
  //         totalReturnAmount: selectedItem?.grandTotal,
  //         remarks,
  //       });

  //       setResponseData(response);
  //       fetchCustomers();
  //       setRemarks("");
  //       setPan("");

  //       toast.success("Selected bill is returned successfully");

  //       // ✅ Call print logic here
  //       printBill({
  //         socketRef,
  //         userInfo,
  //         costCenterData,
  //         currentOrder,          // pass current items if available
  //         totalDiscount,
  //         calculateTotals,
  //         responseData: response,
  //         toast,
  //         setIsPrinting,
  //       });
  //     } catch (error) {
  //       toast.error("Failed to return the bill");
  //     } finally {
  //       toggleDeleteModal();
  //       setSelectedItem(null);
  //     }
  //   }
  // };

  const handleExportExcel = () => {
    const columnMapping = {
      "S.N": (row, index) => index + 1,
      "Invoice No.": "invoiceNumber",
      "Order Reference Id": "orderReferenceId",
      "Bill Date": (row) => formatDate(row.billDate),
      "Discount (%)": "discountPercentage",
      "Total Amount": "grandTotal",
    };

    exportToExcel(filteredData, columnMapping, "SalesReports.xlsx");
  };
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Sales Report List" pageTitle="Sales Report" />
      </div>
      <Row>
        <Col md={8} xs={9} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by invoice no & order referenceId"
              value={filterText}
              onChange={handleFilterChange}
            />
          </InputGroup>
        </Col>
        <Col md={4} xs={3}>
          <div>
            <button className="btn btn-success" onClick={handleExportExcel}>
              Export
            </button>{" "}
          </div>
        </Col>
      </Row>
      <Card className="d-none d-lg-block d-md-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData}
          />
        </CardBody>
      </Card>

      {loading ? (
        <div className="my-5 d-flex justify-content-center d-lg-none d-block">
          <Triangle
            visible={true}
            height="60"
            width="60"
            color="#5B71B9"
            ariaLabel="triangle-loading"
          />
        </div>
      ) : (
        <>
          {filteredData?.map((item, index) => (
            <Card
              key={item.id || index}
              className="mb-3 shadow-sm d-block d-lg-none mt-2"
            >
              <CardBody>
                <Row>
                  <Col xs={12}>
                    <div className="d-flex justify-content-between align-content-center align-items-center">
                      <Link
                        to={`/order/${item?.orderReferenceId}`}
                        className="cursor-pointer "
                      >
                        <h6 className="mb-2 text-primary">
                          {item?.orderReferenceId}
                        </h6>
                      </Link>
                      <div>
                        <Dropdown
                          isOpen={item.dropdownOpen || false}
                          toggle={(e) => {
                            e.stopPropagation(); // prevents parent click handlers

                            setData((prev) =>
                              prev.map(
                                (customer) =>
                                  customer.id === item.id
                                    ? {
                                        ...customer,
                                        dropdownOpen: !customer.dropdownOpen,
                                      }
                                    : { ...customer, dropdownOpen: false } // close all others
                              )
                            );
                          }}
                          direction="down"
                        >
                          <DropdownToggle
                            color="primary"
                            outline
                            className="btn-sm  shadow-sm rounded-circle"
                          >
                            <i className="ri-more-2-fill"></i>
                          </DropdownToggle>
                          <DropdownMenu end>
                            <DropdownItem
                              onClick={() => toggleDetailModal(item)}
                            >
                              <i className="bx bx-show text-success me-2" />{" "}
                              View
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => handleDeleteClick(item.id)}
                            >
                              <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                              Delete
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </div>
                    <h6 className="mb-2">{formatDateTimes(item?.billDate)}</h6>
                    <h6 className="mb-2 d-flex justify-content-between align-content-center align-items-center">
                      <strong>Invoice No</strong>{" "}
                      {item?.invoiceNumber || "none"}
                    </h6>

                    <h6 className="mb-2 d-flex justify-content-between align-content-center align-items-center">
                      <strong>Discount (%)</strong>{" "}
                      {item?.discountPercentage || 0}
                    </h6>
                    <h6 className="mb-0 d-flex justify-content-between align-content-center align-items-center fw-bold">
                      <strong>Total</strong> {item?.grandTotal || 0}
                    </h6>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
        </>
      )}
      {/* <CustomerForm
        modal={addModal}
        toggleModal={() => {
          setAddModal(false);
          setSelectedItem(null); // Clear editing state when closing
        }}
        setData={setData}
        data={data}
        selectedItem={selectedItem}
        fetchCustomers={fetchCustomers}
      /> */}
      <ReturnBill
        show={deleteModal}
        // onDeleteClick={handleReturn}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedItem} // Pass the selected item
        setSelectedItem={setSelectedItem}
      />

      <SalesReportDetail
        isOpen={isDetailOpen}
        toggle={toggleDetailModal}
        selectedItem={selectedItem}
      />
    </div>
  );
};

export default SalesReport;
